export default __webpack_public_path__ + "static/media/Vine_Block.42acbd08.svg";